import { useEffect, useState, useCallback } from "react";
import { api } from "@/api";
import { Cursor } from "@/components/Cursor";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Featured } from "@/components/Featured";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Gallery } from "@/components/Gallery";
import { Contact } from "@/components/Contact";
import { Footer, WhatsAppFloat } from "@/components/Footer";
import { Lightbox } from "@/components/Lightbox";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [featuredIndex, setFeaturedIndex] = useState(null);

  useEffect(() => {
    Promise.all([api.get("/products"), api.get("/categories")])
      .then(([p, c]) => {
        setProducts(p.data);
        setCategories(c.data);
      })
      .catch(() => {});
  }, []);

  const openFeatured = useCallback(
    (p) => {
      const i = products.findIndex((x) => x.id === p.id);
      setFeaturedIndex(i >= 0 ? i : null);
    },
    [products]
  );

  return (
    <div className="bg-background" data-testid="home-page">
      <Cursor />
      <Navbar />
      <Hero />
      <Marquee />
      <Featured products={products} onOpen={openFeatured} />
      <Manifesto />
      <Gallery products={products} categories={categories} />
      <Contact />
      <Footer />
      <WhatsAppFloat />
      <Lightbox
        items={products}
        index={featuredIndex}
        onClose={() => setFeaturedIndex(null)}
        onNavigate={setFeaturedIndex}
      />
    </div>
  );
}
